module.exports = __webpack_public_path__ + "static/img/banner-to-snbt-2023.9d56172.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banners/banner-to-snbt-2023.jpg
// module id = mvjx
// module chunks = 1